<template>
  <!-- eslint-disable vue/attribute-hyphenation -->
  <div class="player">
    <youtube
      ref="youtube"
      class="player__video"
      :resize="true"
      :fitParent="true"
      :video-id="youtubeId"
      :player-vars="playerVars"
    />
  </div>
</template>

<script>

export default {
  components: { },
  data() {
    return {
      playerVars: {
        controls: 1,
        rel: 0,
        modestbranding: 1,
        showinfo: 0,
      },
    };
  },
  computed: {
    youtubeId() {
      const id = (window.___youtube !== '#youtube#') ? window.___youtube : 'qZQp0Zva9yA';
      console.info('youtube id', id);
      return id;
    },
    hasHistory() { return window.history.length > 2; },
  },
};
</script>

<style lang="stylus" scoped>
.player {
  background-color: black;
}

</style>
